import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row align-items-top"
}
const _hoisted_2 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "delete", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "col-auto" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = {
  key: 2,
  class: "col-6"
}
const _hoisted_9 = {
  key: 3,
  class: "col border border-1 d-flex align-items-top"
}
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-wrap w-100 align-items-top mt-2 mb-2"
}
const _hoisted_11 = { class: "ms-3 mt-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mas btn-icon fs-6" }, "add", -1)
const _hoisted_13 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_14 = { class: "text-danger" }
const _hoisted_15 = { class: "d-flex flex-wrap w-100 align-items-center mb-2" }
const _hoisted_16 = ["id", "title", "onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "mas fs-6 ms-1" }, "close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputDate = _resolveComponent("InputDate")!
  const _component_input_select = _resolveComponent("input-select")!

  return (_ctx.visibilityRuleUI.isReady())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.hideDelete)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteVisibilityRule && _ctx.deleteVisibilityRule(...args)), ["prevent"])),
                class: "btn btn-sm btn-icon btn-danger mb-3"
              }, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_InputSelect, {
            modelValue: _ctx.visibilityRule.type_code,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibilityRule.type_code) = $event)),
              _ctx.onChange
            ],
            options: _ctx.visibilityRuleOptions,
            name: "visibilityType",
            label: _ctx.$t('type'),
            selectText: _ctx.$t('selectText'),
            rules: "required",
            errors: _ctx.errors
          }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
        ]),
        (_ctx.visibilityRule.type_code === _ctx.VisibilityRuleTypeEnum.VISIBLE_WITHIN_PERIOD)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_InputDate, {
                  modelValue: _ctx.visibilityRule.begin_date,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibilityRule.begin_date) = $event)),
                    _ctx.onChange
                  ],
                  label: _ctx.$t('begin'),
                  name: "begin",
                  placeholder: "DD-MM-JJJJ",
                  rules: "req_if_end:@begin,@end",
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_InputDate, {
                  modelValue: _ctx.visibilityRule.end_date,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visibilityRule.end_date) = $event)),
                    _ctx.onChange
                  ],
                  label: _ctx.$t('end'),
                  name: "end",
                  placeholder: "DD-MM-JJJJ",
                  rules: "req_if_begin:@begin,@end|comes_after:@begin,@end",
                  errors: _ctx.errors
                }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.visibilityRule.type_code === _ctx.VisibilityRuleTypeEnum.PRODUCT_FILTER_NO_PRODUCTS || _ctx.visibilityRule.type_code === _ctx.VisibilityRuleTypeEnum.PRODUCT_FILTER_WITH_PRODUCTS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.visibilityRule.product_filter_code,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visibilityRule.product_filter_code) = $event)),
                  _ctx.onChange
                ],
                options: _ctx.namedProductFilterOptions,
                label: _ctx.$t('productFilter'),
                name: "product_filter_code",
                selectText: _ctx.$t('selectText'),
                rules: "required|max:50",
                errors: _ctx.errors
              }, null, 8, ["modelValue", "options", "label", "selectText", "errors", "onUpdate:modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.visibilityRule.type_code === _ctx.VisibilityRuleTypeEnum.HIDE_FOR_CLIENT_GROUPS || _ctx.visibilityRule.type_code === _ctx.VisibilityRuleTypeEnum.VISIBLE_FOR_CLIENT_GROUPS)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", null, [
                (_ctx.clientGroupOptions.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_input_select, {
                        ref: "clientGroupField",
                        modelValue: _ctx.newClientGroupCode,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newClientGroupCode) = $event)),
                        name: "clientGroup",
                        options: _ctx.clientGroupOptions,
                        rules: { clientGroupRequired: { currentGroups: _ctx.visibilityRule.client_group_codes } },
                        validateOnInput: false,
                        validateOnChange: false,
                        validateOnBlur: false,
                        errors: _ctx.errors
                      }, null, 8, ["modelValue", "options", "rules", "errors"]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("a", {
                          href: "javascript:void(0);",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addClientGroup())),
                          class: "btn btn-sm btn-outline-success fw-700"
                        }, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('cms.addClientGroup')), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('cms.noClientGroups')), 1)
                    ])),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.selectedClientGroupNames), (i) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: i,
                      class: "selected-client-group btn btn-sm btn-green d-flex justify-content-between align-items-center fs-7 lh-sm text-white text-wrap fw-bold m-1 pe-1",
                      "data-bs-toggle": "tooltip",
                      "data-bs-placement": "top",
                      "data-bs-html": "true",
                      ref_for: true,
                      ref: _ctx.selectedClientGroupNames[i],
                      id: _ctx.visibilityRule.client_group_codes[i] + '_' + i,
                      title: _ctx.selectedClientGroupNames[i],
                      onClick: _withModifiers(($event: any) => (_ctx.removeClientGroup(i)), ["prevent"])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.selectedClientGroupNames[i]), 1),
                      _hoisted_17
                    ], 8, _hoisted_16))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}